import React from "react";

const DisputeLog = () => {
  return <div>DisputeLog</div>;
};

export default DisputeLog;
